import { memo, useCallback, useRef } from 'react';

import { Button } from '@air/primitive-button';
import { cn } from '@air/utils-tailwind';

import {
  WorkspaceAgentAirMark,
  type WorkspaceAgentAirMarkHandle,
} from '~/components/v2/components/workspace/workspace-agent-panel/components/entry/WorkspaceAgentAirMark';
import { agenticStartTaskButton } from '~/components/v2/components/workspace/workspace-agent-panel/components/entry/workspaceAgentStartTaskButtonVariants';
import styles from '~/components/v2/components/workspace/workspace-agent-panel/components/entry/workspaceAgentStartTaskCta.module.css';

export type WorkspaceAgentSelectionBarStartTaskButtonProps = {
  onClick: () => void;
};

/**
 * Selection-bar Start task — standalone agentic-blue CTA. Calls `startNewThread`, not `showChat`.
 */
export const WorkspaceAgentSelectionBarStartTaskButton = memo(
  ({ onClick }: WorkspaceAgentSelectionBarStartTaskButtonProps) => {
    const markRef = useRef<WorkspaceAgentAirMarkHandle>(null);

    const handlePointerEnter = useCallback(() => {
      markRef.current?.replay();
    }, []);

    return (
      <div className={cn(styles.agenticBlueCta, 'inline-flex shrink-0 rounded-8')}>
        <Button
          appearance="filled"
          className={agenticStartTaskButton()}
          color="blue"
          data-testid="SELECTION_ACTION_BAR_START_TASK"
          onClick={onClick}
          onPointerEnter={handlePointerEnter}
          size="medium"
        >
          <WorkspaceAgentAirMark autoplayOnMount ref={markRef} />
          Start task
        </Button>
      </div>
    );
  },
);

WorkspaceAgentSelectionBarStartTaskButton.displayName = 'WorkspaceAgentSelectionBarStartTaskButton';
